import { render, staticRenderFns } from "./StatisticsAndLogs.vue?vue&type=template&id=d5263048&scoped=true&"
import script from "./StatisticsAndLogs.vue?vue&type=script&lang=js&"
export * from "./StatisticsAndLogs.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsAndLogs.vue?vue&type=style&index=0&id=d5263048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5263048",
  null
  
)

export default component.exports